import { z } from 'zod'
import { AssetDeliveryStatus, AssetType, AssetEscalationType } from '@/features/assets/constants'

export const paginatedAssetSchema = z.object({
  assetCode: z.string(),
  projectCode: z.number().int(),
  encryptedProjectCode: z.string(),
  name: z.string(),
  owner: z.string(),
  type: z.nativeEnum(AssetType),
  status: z.nativeEnum(AssetDeliveryStatus),
  systemSize: z.number().nullable(),
})

export const createAssetSchema = z.discriminatedUnion(
  'type',
  [
    z.object({
      type: z.literal(AssetType.Solar),
      unifiiProjectCode: z.number(),
      productId: z.number(),
      ownerId: z.number(),
      systemSize: z.number().gt(0),
      consumptionYield: z.number().gt(0),
      escalationType: z.nativeEnum(AssetEscalationType),
      escalationPercentage: z.number().min(0).max(100),
      vcomSystemKey: z.string().trim().length(6, 'VCOM system key must be exactly 6 characters.')
    }),
    z.object({
      type: z.literal(AssetType.Wheeling),
      energyProProjectCode: z.number(),
      unifiiProjectCode: z.number(),
    }),
    z.object({
      type: z.literal(AssetType.Generator),
    })
  ]
)
